import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Loads Google Analytics 4 only when a measurement ID is configured.
// The lead_submitted events fired elsewhere flow straight into GA once this is live.
export default function Analytics() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined') window.dataLayer = window.dataLayer || [];
    if (!GA_ID || window.__gaLoaded) return;
    window.__gaLoaded = true;
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GA_ID, { send_page_view: false });
  }, []);

  useEffect(() => {
    if (GA_ID && typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', { page_path: pathname });
    }
  }, [pathname]);

  return null;
}
